import React from "react"
import { useStyles } from "@/pages/ai-chat/components/AIChatIcon.styles"

interface Props {
    popdownIsOpen?: boolean
    isOpen?: boolean
}

export const AIChatIcon = (props: Props) => {
    const { classes } = useStyles()

    return (
        <div>
            {/*Chat*/}
            <svg
                className={classes.chatIcon}
                width="15"
                height="15"
                viewBox="0 0 15 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M8.63286 0.143799H1.93695C0.893008 0.143799 0.0810547 0.984751 0.0810547 1.99969V10.3512C0.0810547 11.3952 0.893008 12.2071 1.93695 12.2071H4.72079V14.527C4.72079 14.73 4.80778 14.875 4.95278 14.962C5.12677 15.0199 5.30076 15.0199 5.44575 14.904L5.93872 14.527L6.08371 14.44L6.11271 14.411L9.04154 12.2071H13.0723C14.0873 12.2071 14.9282 11.3952 14.9282 10.3512V6.23721C14.6871 6.32455 14.4284 6.37143 14.1615 6.37143C13.9489 6.37143 13.7384 6.34222 13.5363 6.28545V10.3512C13.5363 10.6122 13.3043 10.8152 13.0723 10.8152H9.04154C8.72256 10.8152 8.43258 10.9312 8.20059 11.1052L6.11271 12.6711V12.2071C6.11271 11.4532 5.47475 10.8152 4.72079 10.8152H1.93695C1.67596 10.8152 1.47297 10.6122 1.47297 10.3512V1.99969C1.47297 1.76771 1.67596 1.53572 1.93695 1.53572H8.68255C8.59382 1.28791 8.54785 1.02457 8.54785 0.75779C8.54785 0.546407 8.57725 0.340211 8.63286 0.143799Z"
                    fill={props.popdownIsOpen && !props.isOpen ? "#503ABD" : "#EBEAFD"}
                />
            </svg>

            {/*Star*/}
            <svg
                className={classes.smallStarIcon}
                width="8"
                height="8"
                viewBox="0 0 8 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.51384 0.234859L5.52038 2.39892L7.68444 3.40546C7.81864 3.47256 7.9193 3.60676 7.9193 3.75774C7.9193 3.9255 7.81864 4.05971 7.68444 4.12681L5.52038 5.13335L4.51384 7.2974C4.44674 7.43161 4.31253 7.51549 4.16155 7.51549C3.9938 7.51549 3.85959 7.43161 3.79249 7.2974L2.78595 5.13335L0.621892 4.12681C0.487687 4.05971 0.403809 3.9255 0.403809 3.75774C0.403809 3.60676 0.487687 3.47256 0.621892 3.40546L2.78595 2.39892L3.79249 0.234859C3.85959 0.100654 3.9938 0 4.16155 0C4.31253 0 4.44674 0.100654 4.51384 0.234859Z"
                    fill={props.popdownIsOpen && !props.isOpen ? "#503ABD" : "#EBEAFD"}
                />
            </svg>

            {/*Star*/}
            <svg
                className={classes.bigStarIcon}
                width="8"
                height="8"
                viewBox="0 0 8 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.51384 0.234859L5.52038 2.39892L7.68444 3.40546C7.81864 3.47256 7.9193 3.60676 7.9193 3.75774C7.9193 3.9255 7.81864 4.05971 7.68444 4.12681L5.52038 5.13335L4.51384 7.2974C4.44674 7.43161 4.31253 7.51549 4.16155 7.51549C3.9938 7.51549 3.85959 7.43161 3.79249 7.2974L2.78595 5.13335L0.621892 4.12681C0.487687 4.05971 0.403809 3.9255 0.403809 3.75774C0.403809 3.60676 0.487687 3.47256 0.621892 3.40546L2.78595 2.39892L3.79249 0.234859C3.85959 0.100654 3.9938 0 4.16155 0C4.31253 0 4.44674 0.100654 4.51384 0.234859Z"
                    fill={props.popdownIsOpen && !props.isOpen ? "#503ABD" : "#EBEAFD"}
                />
            </svg>
        </div>
    )
}
